<template>
  <div class="h-100 d-flex flex-column overflow-hidden">
	<div v-if="showLoader" class="loader1">
			<div>
				<div class="lds-ripple">
				<div></div>
				<div></div>
				</div>
			</div>
		</div>
    <!-- <div class="p-3 d-flex position-relative justify-content-between custom-padding">
      <img src="https://firebasestorage.googleapis.com/v0/b/tatext-thirdpool.appspot.com/o/hiringcenterlogo_4.png?alt=media&token=2f4958c4-702c-4687-9a67-fa23589347b4" height="55" class="mbTopbarDiv1">
      <span class="text-blue custom-cross" @click="closePanel">X</span>
    </div> -->
	
    <div class="bg-dark p-3 d-flex position-relative justify-content-end" v-if="user">
    <!-- <div class="bg-dark p-3 d-flex position-relative justify-content-between ml-auto"> -->
		<b-input-group>
			<b-input-group-append>
				<b-button title="Add Prospect" class="AddProspectUI" variant="primary" @click="$bvModal.show('ProspectModal')">
					<v-icon name="plus" />
				</b-button>
			</b-input-group-append>
		</b-input-group>
      <b-dropdown right variant="outline" toggle-class="text-white" style="z-index: 99999;">
		
            <template v-slot:button-content>
                <b class="HeadUserName">{{$parseAlias(user)}}</b>
            </template>
            
            <b-dropdown-item-button @click="logoutForExt">Logout</b-dropdown-item-button>
        </b-dropdown>
    </div>
    <div class="flex-fill d-flex position-relative" style="min-height: 0">
      <div class="flex-fill d-flex flex-column overflow-hidden">
        <router-view ref="router" @open="open"/>
      </div>
    </div>
	<div v-if="logoutLoader" class="logoutLoader center text-blue" style="z-index:99999;">
		<v-icon name="circle-notch" scale="8" spin />
	</div>
	<b-modal id="ProspectModal" hide-footer>
			<template v-slot:modal-title>
				Create Prospect
			</template>
			<b-form @submit.stop.prevent="createProspect">
				<b-form-group label-cols="5" label="First Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.First"
						required />
				</b-form-group>
				<b-form-group label-cols="5" label="Last Name:" class="my-1">
					<b-form-input
						type="text"
						v-model="form.Last"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Email:" class="my-1">
					<b-form-input
						type="email"
						v-model="form.Email"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Phone number:" class="my-1">
					<b-form-input
						type="tel"
						placeholder="(xxx) xxx-xxxx"
						v-mask="'(###) ###-####'"
						v-model="form.Number"
						/>
				</b-form-group>
				<b-form-group label-cols="5" label="Postal Code:" class="my-1">
					<b-form-input
						type="text"
						@keydown="isCheckPostalCode($event)"
						v-model="form.Zip"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Status:" class="my-1">
					<b-form-select
						:options="user.Stages"
						v-model="form.Status"/>
				</b-form-group>
				<b-form-group label-cols="5" label="Tags:" class="my-1">
					<b-form-checkbox-group v-model="form.Tags">
						<b-form-checkbox :value="user.Folders[i-1]" :key="i" v-for="i in user.Folders.length">
							{{user.Folders[i-1]}}
						</b-form-checkbox>
					</b-form-checkbox-group>
				</b-form-group>
				<b-form-group label-cols="5" label="Notes:" class="my-1">
					<b-form-input
						type="text"
						v-model="NoteValue"/>
				</b-form-group>
				<b-form-checkbox
					v-model="optIn"
					class="my-3"
					required>
						<small>This prospect has given me permission to contact them via text message</small>
				</b-form-checkbox>
				<b-button type="submit" block variant="outline-primary">Save Prospect</b-button>
			</b-form>
		</b-modal>
  </div>
  
</template>


<script>
    // import Header from "./subcomponents/Header.vue";
    // import Nav from "./subcomponents/Nav.vue";
	// import Call from "./Call.vue";
	import { mapState } from 'vuex'
	import { db, auth,getPhoneData } from "src/db.js";

	export default {
		name: 'ChromeHeader',
		props: ['page'],
		components: {
			// Header,
			// // Nav,
			// Call 
		},
		computed: {
			...mapState('globals', ['scrollTop', 'activeConvo', 'activeProsp', 'format']),
			...mapState('firebase', ['prospects', 'convos', 'user','emails','calls','phones']),
		},
		methods: {
			async logoutForExt() {
				try {
					this.logoutLoader = true;
					localStorage.setItem("authProcess", 0);
					localStorage.setItem("authNumber", '');
					await this.disablePushAuth();
					await auth.signOut();
					this.$store.dispatch('firebase/clearBoundData');
					this.$store.dispatch('globals/CLEAR_ALL');
					localStorage.setItem("authSuccess", 0);
					// this.$router.go(2);
					this.$router.push('/Login');
				} catch (err) {
					alert(err);
					return;
				}
			},
			async disablePushAuth() {
				if (this.fcmToken) {
					this.user.fcmTokens[this.fcmToken] = false; //Machine logged out, do not push
					await db.doc(`Users/${this.user.id}`).set(this.user);
				}
			},
			closePanel(){
				//eslint-disable-next-line
				console.log("close");
				window.parent.close();
			},
			open(target) {
				if (this.$route.path != '/chrome/Conversations') {
					this.$router.push('/chrome/Conversations');
					this.$nextTick(() => {
						this.$refs.router.changePage(target);
					})
				} else {
					this.$refs.router.changePage(target);
				}
			},
			async createProspect() {
				if (!this.optIn) {
					alert("Prospect cannot be added unless express permission is given");
					return;
				}
				if (this.NoteValue) {
					let notesArray = [{
						'date': Date.now(),
						'description': this.NoteValue,
						'mediaURL': ''
					}];
					this.form.Notes = notesArray;
				} else {
					this.form.Notes = [];
				}

				this.form.Stages = [{Date:new Date().valueOf(), Stage:this.form.Status}];
				
				this.$bvModal.hide('ProspectModal');
				this.showLoader = true;
				
				if (this.form.Number) {
					await getPhoneData({Number:this.form.Number})
					.then((res) => this.showPhoneData(res))
					.catch(err => this.showPhoneError(err));
				}
				let formattedNum = this.form.Number;
				this.form.Number = this.$parseNumber(this.form.Number);
				this.form.Source = 'Manual Entry';

				var endSpace = /\s+$/;
				if(this.form.First != '' && this.form.First !== 'undefined') {
                    if(endSpace.test(this.form.First)){
                        this.form.First = (this.form.First).replace(/\s+$/,''); 
                    }
                } 
				if(this.form.Last != '' && this.form.Last !== 'undefined') {
                    if(endSpace.test(this.form.Last)){
                        this.form.Last = (this.form.Last).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Email != '' && this.form.Email !== 'undefined') {
                    if(endSpace.test(this.form.Email)){
                        this.form.Email = (this.form.Email).replace(/\s+$/,''); 
                    }
                }
				if(this.form.Zip != '' && this.form.Zip !== 'undefined') {
                    if(endSpace.test(this.form.Zip)){
                        this.form.Zip = (this.form.Zip).replace(/\s+$/,''); 
                    }
                }

				Promise.all([
					db.collection(`Users/${this.user.id}/Prospects`).add({
						...this.form,
						DateCreated: Date.now()
					}),
				])
				.then(values => {
					this.form = {};
					this.form.Status = "New";
					this.optIn = false;
					// this.$bvModal.hide('ProspectModal');
					let prosp = this.prospects.find(prosp => values[0].id == prosp.id);
					if (prosp) {
						setTimeout(() => {
							this.showLoader = false;
							this.emitProsp(prosp);
						}, 3000);
					}
					this.NoteValue = '';
				})
				.catch(err => {
					this.form.Number = formattedNum;
					this.$emit('error', err);
				})
			},
			// ALLOW ONLY LETTERS, DIGITS AND WHITE SPACE
			isCheckPostalCode(e) {
				var value =  e.target.value;
				if (!e.key.match(/[a-zA-Z0-9 ]/) || (e.key == ' ' && value[value.length-1] == ' ')) {
					e.preventDefault();  
				}
			},
			showPhoneData(res) {
				//eslint-disable-next-line
				// console.log(JSON.parse(res.data));
				let phoneData = JSON.parse(res.data);
				this.form.CarrierType = phoneData.carrier.type;
			},
			showPhoneError(err) {
				// this.showPropsLoader = false;
				this.form.CarrierType = null;
				alert(`Not able to find prospect Number Type : `+ err)
			},
			getEmailConvoID(prospId) {
				let mailid = '';
				let mail = this.emails.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (mail) {
					mailid = mail.id;
				}
				return mailid;
			},
			getCallsConvoID(prospId) {
				let phoneid = '';
				let phone = this.calls.find(e => e.Uid == this.user.Uid && e.ProspectID == prospId);
				if (phone) {
					phoneid = phone.id;
				}
				return phoneid;
			},
			emitProsp(prosp) {
				this.search = '';
				let findConvo;
				if(this.convos != null) {
					findConvo = this.convos.find(convo => convo.ClientNumber == prosp.Number);
				}
				this.$store.commit('globals/SET', { var: 'activeProsp', val: prosp.id });
				this.$store.commit('globals/SET', { var: 'activeConvo', val: findConvo.id });
				this.$store.dispatch('firebase/bindMessages', findConvo.id);
				if (this.emails && this.emails.length) {
					//eslint-disable-next-line
					console.log("prospectId",prosp.id);
					let mid = this.getEmailConvoID(prosp.id);
					//eslint-disable-next-line
					console.log("mid",mid);
					if (mid) {
						this.$store.dispatch('firebase/bindMails', mid);
					}else {
						this.$store.dispatch('firebase/clearonlyMailsData');
					}
					// this.$store.dispatch('firebase/bindMails', this.getEmailConvoID(prosp.id));
				}
				if(this.calls != null && this.calls.length){
					let cid = this.getCallsConvoID(prosp.id);
					if (cid){
						this.$store.dispatch('firebase/bindPhones', cid);
					}else {
						this.$store.dispatch('firebase/clearonlyPhonesData');
				}
				}
				// if (this.$route.path != '/chrome/Conversations') {
				// 	this.$router.push('/chrome/Conversations');
				// }
				this.$emit('open', 'prosp');
			},
		},
		data() {
			return {
				error: "",
				onPhone: false,
				callData:{},
				logoutLoader:false,
				form: {
					Status:"New"
				},
				optIn: false,
				NoteValue:'',
				showLoader:false
			}
		}
	}
</script>

<style scoped>
	*{
		padding: 0, 10px;
		margin: 0;
	}
	#ProspectModal___BV_modal_outer_{
		z-index: 99999 !important;
		}
	#Title {
		position: absolute;
		visibility: hidden;
	}
    .custom-cross{
        font-size: 1.5rem;
        border: 2px solid black;
        border-radius: 10px;
        padding: 0px 15px 0px 15px;
		cursor: pointer;
    }
    #Nav {
		position: absolute;
		/* z-index: 1010; */
		z-index: 999;
		height: 100%;
	}
	.nav-button:focus,
	.nav-button:active {
		box-shadow: none;
		outline: 0;
	}
	.nav-button {
		color: white;
		margin-top: 5px;
		margin-bottom: 5px;
		margin-right: 0px;
		margin-left: 0px;
		border-radius: 0;
		position: relative;
	}
	.custom-padding {
		padding: 0.5rem !important;
	}
	@media (min-width: 360px) and (max-width: 640px){
	.mbTopbarDiv1 {
		width: 13em !important;
		height: auto;
	}}
</style>
